import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { delay: Number }

    initialize() {
        this.submit = this.submit.bind(this)
    }

    connect() {
        this.delayValue = this.delayValue || 500
        this.setupClearButton()
    }

    search() {
        this.toggleClear()
        clearTimeout(this.timeout)
        this.timeout = setTimeout(this.submit, this.delayValue)
    }

    submit() {
        this.element.requestSubmit()
    }

    // Clear (×) button — injected into V2 `.search` boxes so a populated
    // search resets in one click. Non-V2 pages render no `.search`
    // container, so they are left untouched. The button carries its own
    // `data-action`, so Stimulus owns the wiring (survives Turbo caching).
    setupClearButton() {
        const box = this.element.querySelector(".search")
        if (!box) return

        this.searchInput = box.querySelector("input:not([type=hidden])")
        if (!this.searchInput) return

        let button = box.querySelector(".search-clear")
        if (!button) {
            button = document.createElement("button")
            button.type = "button"
            button.className = "search-clear"
            button.setAttribute("aria-label", "Clear search")
            button.dataset.action = "search-form#clear"
            button.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
                '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
            button.style.cssText =
                "align-items:center;justify-content:center;flex-shrink:0;width:20px;" +
                "height:20px;padding:0;border:0;border-radius:6px;background:transparent;" +
                "color:var(--ink-3);cursor:pointer"
            box.appendChild(button)
        }

        this.clearButton = button
        this.toggleClear()
    }

    clear() {
        if (!this.searchInput) return
        this.searchInput.value = ""
        this.searchInput.focus()
        this.toggleClear()
        clearTimeout(this.timeout)
        this.submit()
    }

    // Show the clear button only when the search field has text.
    toggleClear() {
        if (!this.clearButton) return
        const filled = !!this.searchInput && this.searchInput.value.trim() !== ""
        this.clearButton.style.display = filled ? "flex" : "none"
    }
}
